@if (treesHeader) {
    <div class="header">
        @if (treesHeader) {
            <ng-container [ngTemplateOutlet]="treesHeader"></ng-container>
        }
    </div>
}
@if (trees) {
    <div class="main">
        @for (tree of trees; track trackByFn($index, tree)) {
            <fui-tree [tree]="tree" [toggled]="toggled" [attr.tree-item-label]="tree.title">
                <ng-template #treeheadercontext let-tree="tree">
                    <ng-container *ngTemplateOutlet="treeHeaderContext; context: $any({tree: tree})"></ng-container>
                </ng-template>
            </fui-tree>
        }
    </div>
}
